import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const PromptButton = ()=>{
    const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/prompt')
    }
    return (
        <Button onClick={handlePage}>Prompt</Button>
    )
}

export default PromptButton